import useSWR from "swr";
import { createAxiosInstance } from "../Axios/createAxiosInstance.ts";

export type ProductInfoDTO = {
  productName: string;
  productId: string;
  priceId: string;
  unitAmount: number;
  currency: string;
  isRenew: boolean;
};
export function useProductInfo({
  productId,
  priceId,
}: {
  priceId: string;
  productId: string;
}) {
  const { data, isLoading } = useSWR(
    `/payment-intent/get-product-info?priceId=${priceId}&productId=${productId}`,
    async (url) => {
      const { data } = await createAxiosInstance().get<ProductInfoDTO>(url);
      return data;
    },
  );

  return {
    loading: isLoading,
    productInfo: data,
  };
}
